(function () {
  class GambleSpin extends PIXI.Container {
    constructor() {
      super();

      this._screenDim = undefined;
      this.gambleActive = false;

      this.visible = false;
      this._screenDimTargetAlpha = 0.6;

      this._currentSpins = undefined;
      this._takeSpinsButton = undefined;
      this._arrow = undefined;
      this._gambleDisc = undefined;
      this._winAnim = undefined;
      this._touchToGamble = undefined;
      this._pointerFinger = undefined;

      this.moveFinger = false;
      this.fingerMoving = false;
      this.fingerTimer = undefined;

      this._winStartAngle = undefined;
      this._winEndAngle = undefined;
      this.loseStartAngle = undefined;
      this._loseEndAngle = undefined;

      this._currentWin = false;

      this.winAnimPositions = [];

      this.pulseTween = undefined;

      this.gambleWinSounds = ['gambleWin1', 'gambleWin2'];
      this.gambleWinSoundIndex = 0;

      this.emitter = undefined;

      let self = this;
      StateMachine.Create(this);
      Reflex.addToUpdate(function () {
        self.update();
      });

      this.stateMachine.addState('IDLE', function () {});
    }

    initialise() {
      const self = this;

      messageBus.subscribe('spinner:GameConfigEvent', function () {
        self.onLayoutComplete();
      });
    }

    update() {
      if (this.stateMachine) {
        this.stateMachine.update();
      }

      if (this.moveFinger && !this.fingerMoving) {
        let self = this;
        this.fingerMoving = true;
        timerManager.addTimer(
          1000,
          function (progress) {
            self._pointerFinger.position.setX(self.fingerStartX + 20 * Math.abs(Math.sin(Math.PI * progress)));
          },
          function () {
            self.fingerMoving = false;
          }
        );
      }
    }

    gambleResultEvent(task) {}

    onLayoutComplete() {
      this._gambleBacker = resourceManager.get('gambleBacker');
      this._gamblePanel = resourceManager.get('gambleSpinContainer:GambleSpin');
      this._currentSpins = resourceManager.get('gambleSpinContainer:GambleSpin:gambleCurrentFreeSpinNum');
      this._nextSpins = resourceManager.get('gambleSpinContainer:GambleSpin:gambleForMoreText');
      this._collectText = resourceManager.get('gambleSpinContainer:GambleSpin:collectText');
      this._betterLuckText = resourceManager.get('gambleSpinContainer:GambleSpin:betterLuck');
      this._takeSpinsButton = resourceManager.get('gambleSpinContainer:GambleSpin:takeSpinsButton');
      this._takeSpinsButton.mousedown = this._takeSpinsButton.touchstart = this.onClickedToContinue.bind(this);
      this._gambleButton = resourceManager.get('gambleSpinContainer:GambleSpin:gambleButton');
      this._gambleButton.mousedown = this._gambleButton.touchstart = this.onCommittedToGamble.bind(this);
      this._arrow = resourceManager.get('gambleSpinContainer:GambleSpin:gambleArrow');
      this._gambleIntroAnimatedPanel = resourceManager.get('gambleSpinContainer:GambleSpin:gambleIntroAnimatedPanel');

      this.setWinAnimPositions();

      this.pulseTween = gsap.fromTo(
        this._gambleButton.scale,
        {
          x: 1,
          y: 1,
        },
        {
          paused: true,
          delay: 0,
          duration: 1,
          x: 1.2,
          y: 1.2,
          yoyo: true,
          repeat: -1,
        }
      );

      messageBus.subscribe('Gamble:Risk', this.onGambleRisk.bind(this));
      messageBus.subscribe('Gamble:Collect', this.onGambleCollect.bind(this));

      this._betterLuckText.visible = false;
      this._collectText.visible = false;

      this.emitter = particleManager.createEmitter(
        'gamble_emitter',
        'gambleSpinContainer:GambleSpin:particlesContainer',
        0,
        0,
        false
      );
      this.emitter.particleEmitter.emit = false;
    }

    onGambleCollect() {
      this._takeSpinsButton.interactive = false;

      this.fadeOut(this._gamblePanel, 1.0);
      this.riseUp(this._gamblePanel, 1.0, this.onGambleCollectAnimationsDone.bind(this));

      let inRecovery = gameController.getIsRecovery();
      if (!inRecovery) {
        this.fadeOut(this._gamblePanel, 1.0);
        this.riseUp(this._gamblePanel, 1.0, this.onGambleCollectAnimationsDone.bind(this));
      } else {
        gameController.fullScreenBubblesFront.startBubbles();
        timerManager.addTimeout(500, function () {
          gameController.fullScreenBubblesFront.stopBubbles();
        });
        gameController.fullScreenBubblesBack.startBubbles();
        musicManager.onPlayBubbleIntro();
        soundManager.play('bonusWon');
        this.onGambleCollectAnimationsDone();
      }
      soundManager.play(soundManifest.getSound('buttonPress'));
      gameData.topLayerMeters.visible = true;
    }

    onGambleCollectAnimationsDone() {
      this.alpha = 1;
      this.visible = false;
      this.stateMachine.switchState('IDLE');
      this.gambleActive = false;
      this._gambleIntroAnimatedPanel.stop();
    }

    onGambleRisk() {
      this._gambleButton.interactive = false;
      this._takeSpinsButton.interactive = false;
      this.resetFinger();

      soundManager.play('gambleStart');
      soundManager.play('gambleSpin');
    }

    resetFinger() {
      if (this.fingerTimer !== undefined) {
        timerManager.stop(this.fingerTimer);
        this.fingerTimer = undefined;
      }

      this.moveFinger = false;
      this.fingerMoving = false;
      this.emitter.particleEmitter.emit = false;
      this.stateMachine.switchState('IDLE');
    }

    onCommittedToGamble() {
      messageBus.postImmediate('Gamble:Risk');
    }

    onClickedToContinue() {
      messageBus.postImmediate('Gamble:Collect');
    }

    setupWheel(winChance, loseChance) {
      var winPercentage = (winChance * 100) / (winChance + loseChance) / 100;
      var losePercentage = 1 - winPercentage;

      var graphics = resourceManager.get('gambleSpinContainer:GambleSpin:gambleSegments');
      graphics.clear();

      this._loseStartAngle = -(losePercentage * Math.PI * 2) / 2 + Math.PI / 2;
      this._loseEndAngle = (losePercentage * Math.PI * 2) / 2 + Math.PI / 2;
      this._winStartAngle = this._loseEndAngle;
      this._winEndAngle = this._loseEndAngle + winPercentage * Math.PI * 2;

      // Winning arc
      graphics.beginFill(0x00c800);
      graphics.lineStyle(0, 0xffffff);
      graphics.moveTo(0, 0);
      graphics.arc(0, 0, 150, this._winStartAngle, this._winEndAngle); // cx, cy, radius, startAngle, endAngle
      graphics.endFill();

      // Losing arc
      graphics.beginFill(0xc80000);
      graphics.lineStyle(0, 0xffffff);
      graphics.moveTo(0, 0);
      graphics.arc(0, 0, 150, this._loseStartAngle, this._loseEndAngle); // cx, cy, radius, startAngle, endAngle
      graphics.endFill();
    }

    start(freeSpins, nextFreeSpins, winChance, loseChance, firstEntry) {
      this.visible = true;

      this._nextSpins.visible = true;
      this._betterLuckText.visible = false;
      this.gambleActive = true;

      this.pulseTween.time(0).restart(true);
      this._nextFreeSpins = nextFreeSpins;

      // gamble spin - needs to set up the gamble wheel ( visually split of red/green based on probability )
      this._currentSpins.text = freeSpins;

      this._takeSpinsButton.visible = true;
      this._gambleButton.visible = false;

      if (freeSpins >= 20) {
        this._nextSpins.setTranslationPhrase('t_maxSpinsReached');
      } else {
        this._nextSpins.setTranslationPhrase('t_gambleTo');
        this._nextSpins.setTranslationParameters(nextFreeSpins);
        this._gambleButton.visible = true;
      }

      resourceManager.get('gambleIntroContainer:GambleIntro').visible = false;
      resourceManager.get('gambleDisclaimerContainer:GambleDisclaimer').visible = false;
      resourceManager.get('gambleSpinContainer:GambleSpin').visible = true;

      this._takeSpinsButton.interactive = true;
      this._gambleButton.interactive = true;

      if (freeSpins < 20) {
        this.setupWheel(winChance, loseChance);
      }

      if (firstEntry) {
        this._arrow.rotation = Math.PI / 2; // first time point arrow horizontally
        this.gambleWinSoundIndex = 0;
        this._gambleIntroAnimatedPanel.play();
      }

      // after five seconds move the finger
      //this.resetFinger();

      messageBus.postImmediate('Gamble:WaitForInput');
    }

    spinToResult(result, callback) {
      this._currentWin = result;
      this._resultShownCb = callback;
      this.pulseTween.time(0).restart(false);
      this._takeSpinsButton.visible = false;
      this._gambleButton.visible = false;

      this.emitter.particleEmitter.emit = true;

      let totalSpins = 4; // number of times to spin the wheel the full 360
      let spinAngle = undefined;
      let safetyAngle = 0.087;

      if (this._currentWin) {
        spinAngle =
          this._winStartAngle +
          safetyAngle +
          gameController.rng.nextFloat() * (this._winEndAngle - safetyAngle - (this._winStartAngle + safetyAngle));
      } else {
        spinAngle =
          this._loseStartAngle +
          safetyAngle +
          gameController.rng.nextFloat() * (this._loseEndAngle - safetyAngle - (this._loseStartAngle + safetyAngle));
      }

      // NOTE: VERY VERY IMPORTANT - spin angle is in arc coordinates so 0 rad = 3pm, whereas the arrow sprite 0 rad = 12pm
      // arrow needs to land at spin angle + PI/2

      let totalSpinDistance = totalSpins * Math.PI * 2.0 + spinAngle + Math.PI / 2; // pi/2 as we need to start at 3pm
      let totalTime = 5000;

      let self = this;
      let baseArrowPos = 0; //this._arrow.rotation;

      timerManager.addTimer(
        totalTime,
        function (progress) {
          var easedRotation = baseArrowPos + Math.sqrt(1 - Math.pow(progress - 1, 2)) * totalSpinDistance; // easing circular

          self._arrow.rotation = easedRotation; //newRotation;

          var emitterAngle = easedRotation - Math.PI / 2;

          var xx = 120 * Math.cos(emitterAngle);
          var yy = 120 * Math.sin(emitterAngle);

          self.emitter.particleEmitter.spawnPos.x = self._arrow.position.x + xx;
          self.emitter.particleEmitter.spawnPos.y = self._arrow.position.y + yy;
        },
        function () {
          self.resultLanded(); /*self._arrow.rotation = spinAngle + ( Math.PI / 2 ); /*totalSpinDistance;*/
        }
      );
    }

    resultLanded() {
      this.emitter.particleEmitter.emit = false;

      if (this._currentWin) {
        soundManager.play(this.gambleWinSounds[this.gambleWinSoundIndex]);

        this.gambleWinSoundIndex++;

        // this.blastAnim.gotoAndPlay(0);

        var duration = 0.3;

        gsap
          .timeline()
          .to(this._currentSpins, {
            duration,
            alpha: 0,
          })
          .to(
            this._currentSpins.scale,
            {
              duration,
              x: 2,
              y: 2,
            },
            '<'
          )
          .call(() => {
            this._currentSpins.text = this._nextFreeSpins;
          })
          .to(this._currentSpins, {
            duration,
            alpha: 1,
          })
          .to(
            this._currentSpins.scale,
            {
              duration,
              x: 1,
              y: 1,
            },
            '<0.2'
          );

        //pixi: { scaleX: 2, scaleY: 2 },
      } else {
        this._currentSpins.text = 0;
        this._nextSpins.visible = false;
        this._betterLuckText.visible = true;

        soundManager.play('gambleLose');

        this.stateMachine.switchState('IDLE');
      }

      // allow time to see results - more time on a lose
      let self = this;
      timerManager.addTimer(
        this._currentWin ? 100 : 1000,
        function () {},
        function () {
          if (self._currentWin) {
            self._resultShownCb();
          } else {
            self.gambleLost(self._resultShownCb);
          }
        }
      );
    }

    gambleLost(callback) {
      gameController.fullScreenBubblesBack.stopBubbles();
      this.fadeOut(this._gambleBacker, 1.0);
      this.fadeOut(this._gamblePanel, 1.0);
      this.fallOff(this._gamblePanel, 1.0);
      gameData.topLayerMeters.visible = false;

      timerManager.addTimeout(1000, function () {
        callback();
      });
    }

    fadeOut(object, duration) {
      gsap.to(object, {
        duration: duration,
        alpha: 0,
        ease: 'power4.in',
        onComplete: () => {
          object.visible = false;
          object.alpha = 1;
        },
      });
    }

    fallOff(object, duration) {
      const originalPosition = {
        x: gsap.getProperty(object, 'x'),
        y: gsap.getProperty(object, 'y'),
      };

      gsap.to(object, {
        duration: duration,
        x: 0,
        y: 1000,
        ease: 'power4.in',
        onComplete: () => {
          object.visible = false;
          gsap.set(object, { x: originalPosition.x, y: originalPosition.y });
        },
      });
    }

    riseUp(object, duration, cb) {
      const originalPosition = {
        x: gsap.getProperty(object, 'x'),
        y: gsap.getProperty(object, 'y'),
      };

      gsap.to(object, {
        duration: duration,
        x: 0,
        y: -1000,
        ease: 'power4.in',
        onComplete: () => {
          object.visible = false;
          gsap.set(object, { x: originalPosition.x, y: originalPosition.y });
          if (cb) {
            cb();
          }
        },
      });
    }

    setWinAnimPositions() {
      this.winAnimPositions = [];
      this.winAnimPositions.push(this._currentSpins.text);
    }
  }

  let gambleSpinCreator = function (json) {
    return new GambleSpin();
  };

  let gambleSpinInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  let gambleSpinFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('GambleSpin', gambleSpinCreator, gambleSpinInitialiser, gambleSpinFilesRequired);
})();
